<template>
  <v-app style="background-color: #fbfbfb">
    <v-main>
      <v-container fluid class="pa-0">
        <v-row justify="center" no-gutters>
          <v-col cols="12" md="10" lg="8">
            <site-header></site-header>
            <snackbar></snackbar>
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
      <scroll-top-button></scroll-top-button>
    </v-main>
    <site-footer :region="region"></site-footer>
  </v-app>
</template>

<script>
import siteHeader from './components/siteHeader';
import snackbar from './components/snackbar';
import siteFooter from './components/siteFooter';
import scrollTopButton from './components/scrollTopButton';

export default {
  name: 'App',
  components: {
    siteHeader,
    snackbar,
    siteFooter,
    scrollTopButton
  },

  data: () => ({
    region: 1
  }),
  created() {}
};
</script>

<style>
html,
body {
  width: 100vw;
}
</style>
